export default __webpack_public_path__ + "static/service_360-fd6b7517baa2472d68121da473ff922d.webp";